"use strict";

var curry = require("./curry.js");

const applyMethod = curry((name, obj, args) => obj[name].apply(obj, args));
module.exports = applyMethod;